const EMAIL_REGEX_PATTERN = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
const MOBILE_NUMBER_REGEX_PATTERN = /^(\+91[\-\s]?)?[0]?(91)?[6789]\d{9}$/;

export const toTitleCase = (str = '') => str.replace(/\w\S*/g, (txt) => txt[0].toUpperCase() + txt.slice(1).toLowerCase());

export const isValidEmail = (email = '') => EMAIL_REGEX_PATTERN.test(email);

export const isValidPhone = (num = '') => MOBILE_NUMBER_REGEX_PATTERN.test(num);


export const isValidAadhaar = (num) => /^\d{12}$/.test(num);

const STATUS_COLOR_OBJ = {
  "pending": "warning",
  "approved": "success",
  "rejected": "danger"
}

export const showStatus = (status='') => {
  const color = STATUS_COLOR_OBJ[status] || "success";
  const className = "badge badge-pill badge-" + color;

  return <span className={className}>{toTitleCase(status)}</span>
}

export const achievementOptions = [
  {label: 'Select', value: ''},
  { label: 'Gold', value: 'Gold' },
  { label: 'Silver', value: 'Silver' },
  { label: 'Bronze', value: 'Bronze' }
]

export const IMAGE_UPLOAD_ENDPOINT = "https://api.cloudinary.com/v1_1/dnut9ipl0/image/upload"
